import { all } from 'redux-saga/effects';
import { oohSegmentsWatcher } from './oohSegements/oohSegmets.saga';

export const customAudienceSaga = function* rootSaga() {
  yield all([oohSegmentsWatcher()]);
};
